import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _BellPinFill(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13.794 3.295a5.586 5.586 0 0 0-7.346 4.674l-.252 2.267-.006.057a8 8 0 0 1-1.073 3.18l-.03.05-.578.963c-.525.874-.787 1.311-.73 1.67a1 1 0 0 0 .346.61c.278.234.788.234 1.807.234h12.136c1.02 0 1.53 0 1.808-.233a1 1 0 0 0 .346-.611c.056-.359-.206-.796-.73-1.67l-.579-.964-.03-.05a8 8 0 0 1-.96-2.473 5 5 0 0 1-4.129-7.704m2.48 1.694a5.57 5.57 0 0 1 1.276 2.96 2 2 0 0 1-1.276-2.96", clipRule: "evenodd" }),
            React.createElement("path", { fill: "currentColor", d: "M9 17a3 3 0 0 0 6 0H9" }),
            React.createElement("circle", { cx: 18, cy: 6, r: 2.5, fill: "currentColor", stroke: "currentColor" })));
}
const BellPinFill = forwardRef(_BellPinFill);
export { BellPinFill };
